module.exports = {
	"ajax": {
		"fail": "Échec de la demande. S'il vous plaît, rechargez la page et essayez de nouveau.",
		"fetchItemsFail": "Échec lors de l'obtention des __itemType__ additionels."
	},
	"genericError": "Une erreur inconnue s'est produite.",
	"oneError": "L'erreur suivante s'est produite",
	"manyErrors": "Les erreurs suivantes se sont produites",
	"invalidLogin": "Nom d'utilisateur ou mot de passe incorrect.",
	"noDataReceived": "Aucune donnée reçue.",
	"organization": {
		"accessInvitesEmailDuplicated": "L'utilisateur associé à cette adresse courriel a déjà accès à ce compte.",
		"contactAddressRequired": "Vous devez fournir une adresse.",
		"contactCityRequired": "Vous devez fournir une ville.",
		"contactCountryRequired": "Vous devez fournir un pays.",
		"contactEmailInvalid": "Vous devez fournir une adresse courriel valide.",
		"contactEmailRequired": "Vous devez fournir une adresse courriel.",
		"contactPostalCodeRequired": "Vous devez fournir un code postal.",
		"contactRegionRequired": "Vous devez fournir une région.",
		"contactTelephoneRequired": "Vous devez fournir un numéro de téléphone.",
		"contactWebsiteInvalid": "Vous devez fournir un site web valide.",
		"friendlyIdRequired": "Vous devez fournir un URL convivial.",
		"nameRequired": "Vous devez fournir un nom d'encanteur.",
		"notFound": "Encanteur introuvable. L'encanteur demandé n'existe pas.",
		"staffInvitesEmailDuplicated": "L'utilisateur associé à cette adresse courriel a déjà accès à ce compte d'encanteur."
	},
	"auction": {
		"bidEndDateInvalid": "La date de fin des pré-offres que vous avez fournie pour l'encan est invalide.",
		"bidEndDateRequired": "Vous devez fournir la date et l'heure de fin des pré-offres pour l'encan.",
		"bidStartDateInvalid": "La date de début des pré-offres que vous avez fournie pour l'encan est invalide.",
		"bidStartDateRequired": "Vous devez fournir la date et l'heure de début des pré-offres pour l'encan.",
		"endDateInvalid": "La date de fin que vous avez fournie pour l'encan est invalide.",
		"endDateRequired": "Vous devez fournir la date et l'heure de fin de l'encan.",
		"locationAddressRequired": "Vous devez fournir une adresse pour l'emplacement de l'encan.",
		"locationCityRequired": "Vous devez fournir une ville pour l'emplacement de l'encan.",
		"locationPostalCodeRequired": "Vous devez fournir un code ZIP ou un code postal pour l'emplacement de l'encan.",
		"locationRegionRequired": "Vous devez fournir une région pour l'emplacement de l'encan.",
		"nameRequired": "Vous devez fournir un nom.",
		"notFound": "Enchère introuvable. L'enchère demandée n'existe pas.",
		"readOnly": "Enchère en lecture seule. Vous n'êtes pas autorisé à la modifier.",
		"startDateInvalid": "La date de début que vous avez fournie pour l'encan est invalide.",
		"startDateRequired": "Vous devez fournir la date et l'heure de début de l'encan."
	},
	"authentication": "Erreur d'authentification.",
	"lot": {
		"notFound": "Lot introuvable. Le lot demandé n'existe pas."
	},
	"upload": {
		"invalidFile": "Le fichier envoyé n'est pas valide.",
		"tooLarge": "Le fichier que vous souhaitez envoyer est trop grand. (La taille maximale est de 10 Mo)",
		"wrongType": "Vous devez envoyer un fichier de type JPG ou PNG."
	},
	"bid": {
		"alreadyLeading": "Vous détenez déjà l'enchère gagnante.",
		"bidLimitExceeded": "Vous avez dépassé votre enchère maximale de __limit__ pour un même lot.",
		"invalidAmount": "Vous devez entrer un montant d'enchère valide.",
		"noBidPermissions": "Vous ne possédez pas suffisamment de privilèges pour enchérir dans cet encan.",
		"notAllowed": "Les enchères sont présentement fermées, soit parce que la période où elles sont permises est terminée, soit parce que l'encan est en cours.",
		"purchaseLimitExceeded": "Vous avez dépassé votre limite d'achats de __limit__ pour un même encan.",
		"somethingWrong": "Une erreur s'est produite avec votre enchère.",
		"tooLow": "L'enchère est trop basse."
	},
	"email": {
		"alreadyExists": "Cette adresse courriel est déjà utilisée par un autre utilisateur.",
		"required": "Vous devez fournir une adresse courriel valide.",
		"invalid": "Vous devez fournir une adresse courriel."
	},
	"errorWithField": "Erreur de la base de données avec le champ: __field__.",
	"item": {
		"nameRequired": "Vous devez fournir un nom pour l'article."
	},
	"phone": {
		"required": "Vous devez fournir un numéro de téléphone."
	},
	"primaryEmailNotConfirmed": "Vous devez confirmer votre adresse courriel avant d'avoir accès à cette fonction.",
	"subscription": "Erreur avec l'abonnement.",
	"subscriptionLimitReached": "Les limites de votre abonnement actuel ont été atteintes.",
	"unexpected": "Une erreur inattendue en lien avec __related__ s'est produite. $t(general::pleaseTryAgain)",
	"userList": {
		"alreadyExists": "Une autre liste d'utilisateurs avec le même nom existe déjà.",
		"nameRequired": "Vous devez fournir un nom pour la liste d'utilisateurs",
		"invalidEmail": "$t(errors::email.invalid)"
	},
	"user": {
		"emailRequired": "$t(errors::email.required)",
		"nameRequired": "$t(errors::auction.nameRequired)",
		"notFound": "Utilisateur introuvable. L'utilisateur demandé n'existe pas.",
		"passwordRequired": "$t(password::pwFieldEmpty)",
		"phoneRequired": "$t(errors::phone.required)"
	},
	"wrongCurrentPassword": "Mauvais mot de passe actuel."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/errors.json5
// module id = 1981
// module chunks = 6